import store from '../store';
import Item from '../views/listings/Items'
import UserItem from '../views/listings/UserItems'
import User from '../views/listings/Users'
import {checkauth} from "../Helper";

export default [
    {
        path: '/listings/:id/items/',
        name: 'listingsitems',
        component: Item,
        beforeEnter (to,from,next){
            checkauth().then( response =>{

                    if(response){
                        //console.log("login")
                        next();
                    }else{
                        //console.log("next")
                        next('/login');
                    };
                }

            )
        }
    },
    {
        path: '/listings/:id/users/',
        name: 'listingsusers',
        component: User,
        beforeEnter (to,from,next){
            checkauth().then( response =>{

                    if(response){
                        //console.log("login")
                        next();
                    }else{
                        //console.log("next")
                        next('/login');
                    };
                }

            )
        }
    },
    {
        path: '/listings/:id/users/:user',
        name: 'usersitems',
        component: UserItem,
        beforeEnter (to,from,next){
            checkauth().then( response =>{

                    if(response){
                        //console.log("login")
                        next();
                    }else{
                        //console.log("next")
                        next('/login');
                    };
                }

            )
        }
    },


]
